import i18n from 'i18next';

const getGenderName = (gender: string) => {
  if (!gender) return gender;
  
  const normalizedInput = gender.toLowerCase().trim();
  
  // Standard enum values to translation keys mapping
  const genderTranslationMap: Record<string, string> = {
    'woman': 'woman',
    'man': 'man',
    'diverse': 'diverse'
  };
  
  // First check with standard enum values
  for (const [standardKey, translationKey] of Object.entries(genderTranslationMap)) {
    if (normalizedInput === standardKey) {
      return i18n.t(translationKey);
    }
  }
  
  // Then check current language translations
  for (const translationKey of Object.values(genderTranslationMap)) {
    const translatedValue = i18n.t(translationKey);
    if (normalizedInput === translatedValue.toLowerCase()) {
      return translatedValue;
    }
  }
  
  // Return original value if no match found
  return gender;
};

export default getGenderName;
